import type { Place } from '~/types/types';


export const placesRepository = () => {
  const { $api } = useNuxtApp()
  return {
    async get(filters: Record<string, any> = {}, page: number = 1): Promise<{ data: Place[]; nextPage: number | null }> {
      
      const visitedPlaceIds = useCookie<string[]>('visitedPlaceIds', { default: () => [] }).value || [];

      const locationCookie = useCookie<{ lat: number; lng: number }>('location', {
        default: () => ({ lat: 0, lng: 0 })
      });

      const visitedPlaceParams = visitedPlaceIds.reduce((acc, id, index) => {
        acc[`visitedPlaceIds[${index}]`] = id;
        return acc;
      }, {} as Record<string, string>);
    

      const response = await $api<{ data: Place[]; meta: { current_page: number; last_page: number } }>('places', {
        method: 'GET',
        params: { ...filters, page ,
          ...visitedPlaceParams, // Adds visitedPlaceIds[0], visitedPlaceIds[1], etc.
          latitude: locationCookie.value.lat ? locationCookie.value.lat : null,
          longitude: locationCookie.value.lng ? locationCookie.value.lng : null,
        }, // Add page dynamically
      });

      // Ensure response and meta exist before accessing them
      const nextPage = response?.meta?.current_page && response?.meta?.current_page < response?.meta?.last_page 
        ? response.meta.current_page + 1 
        : null;

      return {
        data: response.data,
        nextPage, // Returns the next page number or null if no more pages
      };
    },
    /**
     * Fetches category by ID.
     * @param {string} id - The ID of the category to filter places.
     * @returns {Promise<Place>} - The places under the given category.
     */
    async showById(id: string): Promise<Place> {

      // send category_id in fetch
      const response = await $api<{ data: Place }>(
        `places/${id}` // Send as query param
      );

      return response.data;
    },
    /**
     * Fetches category by ID.
     * @param {string} id - The ID of the category to filter places.
     * @returns {Promise<Place>} - The places under the given category.
     */
    async showByTenant(tenant: string): Promise<Place> {

      // send category_id in fetch
      const response = await $api<{ data: Place }>(
        `places/tenant/${tenant}` // Send as query param
      );

      return response.data;
    },
  }
};
